import {createSorter} from './sorter';

const sorter = createSorter(null, {
  name: 'sorter',
  debug: false
});

export {sorter};
